import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listClubs = () =>
  axios.get(`${getV1RootUrl()}/club/for-web`, publicAxiosHeader());

export const getClub = (slug) =>
  axios.get(`${getV1RootUrl()}/club/slug/${slug}/for-web`, publicAxiosHeader());
